import React from 'react';
import { CheckCircle } from 'lucide-react';
import AuthLayout from './AuthLayout';
import Button from './Button';
const VerifiedAccountPage = () => {
  const handleContinue = () => {
    window.location.href = '/login';
  };
  return <AuthLayout title="Account Verified" data-id="element-269">
      <div className="text-center space-y-6" data-id="element-270">
        {/* Success icon */}
        <div className="flex justify-center" data-id="element-271">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center" data-id="element-272">
            <CheckCircle className="w-12 h-12 text-green-600" data-id="element-273" />
          </div>
        </div>

        {/* Success message */}
        <div className="space-y-3" data-id="element-274">
          <h2 className="text-2xl font-semibold text-gray-900" data-id="element-275">
            Verification Successful!
          </h2>
          <p className="text-gray-600 leading-relaxed" data-id="element-276">
            Your account has been successfully verified. You can now access all
            platform features.
          </p>
        </div>

        {/* CTA Button */}
        <div className="pt-4" data-id="element-277">
          <Button onClick={handleContinue} className="w-full" data-id="element-278">
            Continue to Login
          </Button>
        </div>
      </div>
    </AuthLayout>;
};
export default VerifiedAccountPage;